
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqDjHZeECsZ8bXfkneizAiA3FuxzAo6TzuQyciWd7vufIMeta } from "/codebuild/output/src1779356255/src/src/pages/faq.vue?macro=true";
import { default as menuciKIwmNbk9IL4ND_45YxTu_458pqkW2v1A_kuEliRUMiZ3wMeta } from "/codebuild/output/src1779356255/src/src/pages/menu.vue?macro=true";
import { default as indexAr1uz87_45RD7SSq3SArD5u33_PqtwNlYa_jLmlDfp0X8Meta } from "/codebuild/output/src1779356255/src/src/pages/index.vue?macro=true";
import { default as contactWdNisnDJDoW5u_YjawaE9Uwzq_2kiS4eteom4OYBTngMeta } from "/codebuild/output/src1779356255/src/src/pages/contact.vue?macro=true";
import { default as tutorialnqFzvk0iDJRFEPJ_45zFAx3sgVNZIYx19AQP3XD5ODSvgMeta } from "/codebuild/output/src1779356255/src/src/pages/tutorial.vue?macro=true";
import { default as agreement1HVY648YRM2XN_45ayfwSPTuEt2NnJSSwoiI_9uimey_450Meta } from "/codebuild/output/src1779356255/src/src/pages/agreement.vue?macro=true";
import { default as about_45passzzfFTNPQ3pQz_45SxT3NTt4GYI0VAQZ2n5zb2vJEEIzoYMeta } from "/codebuild/output/src1779356255/src/src/pages/about-pass.vue?macro=true";
import { default as indexMwC3_45FmE_45_45p8wbKI852z_tCSC_8nE1DfIztyqHtbiJgMeta } from "/codebuild/output/src1779356255/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93lXsjMpfH27oUXjHPHkKK3dYl8w81QLhv2AWSpbsXYVgMeta } from "/codebuild/output/src1779356255/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceeUqXpRwYYuafehtgGdOwW3nWjmK5ClAIHh7W81LsNaoMeta } from "/codebuild/output/src1779356255/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93WQJ9Dbz2iWz4L0NHjfTJVPqs6NWZFqnCuS_45q42nKMS8Meta } from "/codebuild/output/src1779356255/src/src/pages/notice/[id].vue?macro=true";
import { default as indexrhkQ9A2Ggdyb3UPM01OqIJBOBasu15EGY8bKVavhgLwMeta } from "/codebuild/output/src1779356255/src/src/pages/coupon/index.vue?macro=true";
import { default as indexQud6QU35_45k_PvZyEr_45wfFSHd60pZ_CvcrMKBDD0c7XgMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/index.vue?macro=true";
import { default as indexro5PvrSInQjqmtXN1QWltfEkjwk_45EhiUtGwboHD_oAQMeta } from "/codebuild/output/src1779356255/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Mo4V20uD6RFRpyaRO0w32JUJMT37SG8c13GL1kjmXqAMeta } from "/codebuild/output/src1779356255/src/src/pages/parking/[id].vue?macro=true";
import { default as indexrc5x6ArD8vvZcTp3c0uH26hGhaFgCMVg_5k5x28NE3AMeta } from "/codebuild/output/src1779356255/src/src/pages/history/index.vue?macro=true";
import { default as indexyWLiOOdpu9xNUTK9N30667Y5ad6NpeLsMGE_8bysIGkMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/index.vue?macro=true";
import { default as indexPH_45xmy60pzT21bD_dp_45Kb1RFEOs_45_glggpqjV5YgUfAMeta } from "/codebuild/output/src1779356255/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexdag4yyfaNXQDe4mJaKHwEBoUHxBPfTD3ygrXjPO81OoMeta } from "/codebuild/output/src1779356255/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavihX_45LzsTYjuvmN1ceF0CQYHlPVfyjO4Nk4i2lFDbLokQMeta } from "/codebuild/output/src1779356255/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editbvTYQB8a78XUl0rTHP1oLstBD5RUfCSwu__45kZyKqaCcMeta } from "/codebuild/output/src1779356255/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement7VgwKuEILlDzHMDT2_LJf_45N_6l_HOtRr9GlLiJkZ070Meta } from "/codebuild/output/src1779356255/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexne03p9oR2M4ycLbXI55ItZmtrJ_45_2ts5zrLYx_ODjd4Meta } from "/codebuild/output/src1779356255/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d7EgwXHFOai4nXti4xpwzbSQqGSCOFNxSlAbquLYZFwEMeta } from "/codebuild/output/src1779356255/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmsGQiSgo_0gMjFbvmLZ5a2I1NQ4XUJcglvpEn05zboVsMeta } from "/codebuild/output/src1779356255/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexKP7fh79caSIDicYcKcnaoUvE_RP7mNjRihEdLx1pvnYMeta } from "/codebuild/output/src1779356255/src/src/pages/card/create/index.vue?macro=true";
import { default as indexAOtrwnifqlsD_kTUO8RpOIWyDnBujIEKxNc4leJYsOkMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmknQ487O81i4KduUW0wN99dlGrXe9_xLB0fabtxSLZ7QMeta } from "/codebuild/output/src1779356255/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmJlSvaBz92RTZgEM6d4HlVmI8f_S7S3j6hPq3EGCg3gsMeta } from "/codebuild/output/src1779356255/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeUhluuogNz74iduVnbWJApIq_458MwIzLQF69_45UDnkb2tQMeta } from "/codebuild/output/src1779356255/src/src/pages/membership/complete.vue?macro=true";
import { default as registerkSpOHz7qnyYchJWYQC_454FzcrwR30Oo3DuhNVsoKVq0IMeta } from "/codebuild/output/src1779356255/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93bcIVJWALQNVlZ17_nq9kEJCaSU2vQvThXj8wMFj7moEMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm33fTR81eRCeLGe9gMdGHxxJWANi1ldJuah4mowJGVsoMeta } from "/codebuild/output/src1779356255/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93hVqQKFAfuACwIrO0suPjZW6EcWgYGphNlmTJCt_45M6V8Meta } from "/codebuild/output/src1779356255/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexwhfyQLtkuI5sd2AGRqxxEtlSt0BtZB_nacSk425Lf_45QMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeLTlB1oiC5LudFhNYYpTyfzcOd3Q1ZndgqJRjYpOA8SoMeta } from "/codebuild/output/src1779356255/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeIIxeLs7aYTZylhfdxAfjm6Frcun1_xMVXiCZdo28G3YMeta } from "/codebuild/output/src1779356255/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeoJHhkSm9ZgOw8gIpt2DXLjWoio5junsMux7lLUucOHMMeta } from "/codebuild/output/src1779356255/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeraAIi1xJo4zgMBdlyF8ml_45SkxACbskErambQsl5Cw5QMMeta } from "/codebuild/output/src1779356255/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete2UcD6eI00L9Us_45gJvXq7tj6c_EHqcOwApgVcQgsVGXIMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexAFCDliue2bXJFs_459PlveYDvPLgSsBjVCOJyRI5mhO9AMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm06EO7SJW8EAm3gqhmthOuJ_52XKpg539kVvknSOeOfwMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completezUjB7vnpqwXUor5CEBMCgUtcYi0iH326WAi3jjjx44cMeta } from "/codebuild/output/src1779356255/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexCikofPEH_XTgPnndKu86AS1aguqjdYyiu8GzDlkr2D0Meta } from "/codebuild/output/src1779356255/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93DPz8ZD0s0Y42QdBKQk_45vVNZv47cejoXasIcXd0YdT4sMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeTkdU_45Z_45FTfFU2bkqnhMNq5ME0zhnrlqDF_45EpPfixUewMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasK5t2XsyNZ7D0N2JuBxFwRqs22uXNEGkzEU__45lO1oIbwMeta } from "/codebuild/output/src1779356255/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplewcs9n8ShjPM7_45c6QUx__hRBnxYdauYyvh_45EPyL5SAcwMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailgSm67h4oA4gLSsv1_457iuFBHQZItdfR87J2VhAv16VBsMeta } from "/codebuild/output/src1779356255/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmEJcczRM5U60TZM8lVddj6ehsdMcG4dNzX2uW89EQ04YMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent9p1n_45YoopzthKgwUPm4z5cRzxs_0UvKcmhO_45JRAXcSoMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmbKTj4mLTnOz_KpsJuY9KdiijEXkwEkaZ5G8X29iQ6tgMeta } from "/codebuild/output/src1779356255/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateBPlf3nFLpO1DX5aY7qLgmcuSu5Dwi8NugJvuZeiNeVQMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete6tBXYZ3TVDFdubYx56d1_8C1WbH7iykCexjXfshew5oMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeTcFpvT_ZKskxjmWIV_45e_456n7roeaPhwUfS2x1_qn6j7cMeta } from "/codebuild/output/src1779356255/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordB_0bRz_CFS0DnsLoMXN1IfTWHmC9sbcuaenEDE_DSYgMeta } from "/codebuild/output/src1779356255/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasqen02saEQ6cpjpEcU4x0InnkyRbcgsesDZQumyAtAvwMeta } from "/codebuild/output/src1779356255/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerDxlGMe5mHlRWxmvXbKUryucSCplk92Lc8hAZh0n_ZlYMeta } from "/codebuild/output/src1779356255/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codexPo5JGAsb0XYBTn7qUH5Sx2NH_45nT6nq4RrEYj8YK0kgMeta } from "/codebuild/output/src1779356255/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexYC0v1K196FXvXJWJX6d3DE1LSYV4WfVFE6BeM1Xowu8Meta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexNuEuCC514DpplAqoBrV_Y_45zw_Wu_4518k_45ppQL3WX8DDAMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexAg6h2s76xJWNMtiBUQ0_cL84nRxoj45YwkUj6XkpNIcMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexDv7Fn7jgwwX_hdUMBL7Au8PmwbXJWr7M15bQX9oXnXUMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateb_jUTA_MTGc_TMxwhZHzSJJ3iAOkkQUZQMpuf8wGzIcMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeblIYOaxRkX19fzn8gBsmcaS7dkGv7ES2GljFrPYhvU8Meta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmSCQ9Jj2iFo8b5tU9W1gKpjmTwt9sF5jPv_45ZA_qKDP5sMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index9mx6awU3QN1V6ExDSC_45lNiHrSl4LKw82qxndF_45TrDXEMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeEYEbFcnYIkhrhB9Uk34cnJz6pPJ_45IJZRGAB_ssnUn58Meta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateNCmpYXuQvXuKZvvVpskKRhiVoqdE_MCj_45XJT34S02fQMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexfPBN1Wj2i_45HkdzLIRC6dJj_BS073qRv7NHz5bDuPJqoMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index56ZxtAreHLjuM1cg9W_45BgVFrhO7ojU9IyvIoQ2hH3cMMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completedlbt_45DhHRYVBze7XA53pwKDNg84_d61v5WqvFoPDxkoMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexsgivqJHbsbtvZEgv2AJql2uNx3l7bQoP59r1dTRFvuQMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codepHTgQx7psNDpUnf2qJOPRWa2VGZ1kf88YwNmF4U4bAcMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexfLSe5fAbqqjwVMm4xPIR2xIUMG4Mo88a1GOmmiljWjAMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexY_3T8CuwOIyFrz1e0O6HFklAqtpydAv55_GyUlgujw4Meta } from "/codebuild/output/src1779356255/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexsOw1HmDb2rgmhy4AtMseUWu2oy53_45oqICPSI8e_453suoMeta } from "/codebuild/output/src1779356255/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateH2JBL4CACjTmEEOP8rx_YJ6bUeKKCCZe0ldzKeLHtyoMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmWsYR8BR_nrohn_45U_450iBso_459_rQFavcToW_45gtyOfmvfwMeta } from "/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuciKIwmNbk9IL4ND_45YxTu_458pqkW2v1A_kuEliRUMiZ3wMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexAr1uz87_45RD7SSq3SArD5u33_PqtwNlYa_jLmlDfp0X8Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexrhkQ9A2Ggdyb3UPM01OqIJBOBasu15EGY8bKVavhgLwMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexrc5x6ArD8vvZcTp3c0uH26hGhaFgCMVg_5k5x28NE3AMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexPH_45xmy60pzT21bD_dp_45Kb1RFEOs_45_glggpqjV5YgUfAMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexdag4yyfaNXQDe4mJaKHwEBoUHxBPfTD3ygrXjPO81OoMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexKP7fh79caSIDicYcKcnaoUvE_RP7mNjRihEdLx1pvnYMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmknQ487O81i4KduUW0wN99dlGrXe9_xLB0fabtxSLZ7QMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmJlSvaBz92RTZgEM6d4HlVmI8f_S7S3j6hPq3EGCg3gsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeUhluuogNz74iduVnbWJApIq_458MwIzLQF69_45UDnkb2tQMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerkSpOHz7qnyYchJWYQC_454FzcrwR30Oo3DuhNVsoKVq0IMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm33fTR81eRCeLGe9gMdGHxxJWANi1ldJuah4mowJGVsoMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeLTlB1oiC5LudFhNYYpTyfzcOd3Q1ZndgqJRjYpOA8SoMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeIIxeLs7aYTZylhfdxAfjm6Frcun1_xMVXiCZdo28G3YMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeoJHhkSm9ZgOw8gIpt2DXLjWoio5junsMux7lLUucOHMMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeraAIi1xJo4zgMBdlyF8ml_45SkxACbskErambQsl5Cw5QMMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm06EO7SJW8EAm3gqhmthOuJ_52XKpg539kVvknSOeOfwMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completezUjB7vnpqwXUor5CEBMCgUtcYi0iH326WAi3jjjx44cMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexCikofPEH_XTgPnndKu86AS1aguqjdYyiu8GzDlkr2D0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeTkdU_45Z_45FTfFU2bkqnhMNq5ME0zhnrlqDF_45EpPfixUewMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplewcs9n8ShjPM7_45c6QUx__hRBnxYdauYyvh_45EPyL5SAcwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailgSm67h4oA4gLSsv1_457iuFBHQZItdfR87J2VhAv16VBsMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmEJcczRM5U60TZM8lVddj6ehsdMcG4dNzX2uW89EQ04YMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent9p1n_45YoopzthKgwUPm4z5cRzxs_0UvKcmhO_45JRAXcSoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmbKTj4mLTnOz_KpsJuY9KdiijEXkwEkaZ5G8X29iQ6tgMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete6tBXYZ3TVDFdubYx56d1_8C1WbH7iykCexjXfshew5oMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeTcFpvT_ZKskxjmWIV_45e_456n7roeaPhwUfS2x1_qn6j7cMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordB_0bRz_CFS0DnsLoMXN1IfTWHmC9sbcuaenEDE_DSYgMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerDxlGMe5mHlRWxmvXbKUryucSCplk92Lc8hAZh0n_ZlYMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codexPo5JGAsb0XYBTn7qUH5Sx2NH_45nT6nq4RrEYj8YK0kgMeta || {},
    component: () => import("/codebuild/output/src1779356255/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1779356255/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]